var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/****************************************
 *  Type guards                         *
 ****************************************/
export function isRequestDataAction(a) {
    return a.type === 'REQUEST_DATA';
}
export function isWebsocketAction(a) {
    return a.type === 'WS_MESSAGE';
}
// Appends the collection key to an action's type in order to clarify what part
// of the store the action is affecting. In the case of a websocket message,
// this appends the type of the message.
// Used by @ngrx/store-devtools
export function datastoreActionSanitizer(action, id) {
    if (!action.payload) {
        return action;
    }
    var ids = action.type !== 'WS_MESSAGE' && action.payload.ref.path.ids
        ? action.payload.ref.path.ids.join(', ')
        : undefined;
    return __assign({}, action, { type: action.type + " [" + action.payload.type + "] " + (ids ? " - " + ids : '') });
}
